<div class="row margin-top-20" id="divProperties">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="border-div">
      <div class="d-flex chart-box-header align-item-center margin-bottom-20">
        <h2 class="mainhead mr-auto mainhead2 margin-bottom-0">
          <span class="text" *ngIf="PortfolioName=='My Portfolio'">My Properties</span>
          <span class="text" *ngIf="PortfolioName!='My Portfolio'">{{PortfolioName}}'s Properties</span>
        </h2>
        <div class="like-view-div  margin-right-20">
        </div>
      </div>
      <div class="text-right margin-bottom-15" *ngIf="IsShowMyproperty==2">
        <button class="right-btn btn btn-border btn-addgreen" placement="left" (click)="openAddNewProperty()"> + ADD PROPERTY</button>
      </div>
      <div class="d-flex chart-box-header align-item-center margin-bottom-20 div-no-prop-background" *ngIf="IsShowMyproperty==1">
        <h5 class="mr-auto margin-bottom-0">
          <i container="body" class="userpermissiontooltip margin-right-5" triggers="mouseenter:mouseleave" aria-hidden="true" placement="right">
            <img src="/assets/img/Frame.svg" class="info-icon-blue-position">
          </i>
          <span>Add A Property To View Tenant Market Data</span>
        </h5>
        <div class="text-right">
          <button class="right-btn btn btn-border btn-addgreen" placement="left" (click)="openAddNewProperty()"> + ADD PROPERTY</button>
        </div>
      </div>
      <div class="{{IsShowMyproperty==1?'bg-no-properties':'main-property-div'}}">
        <div class="border-div" *ngFor="let properties of MyTenants;let i = index " style="margin-bottom:15px !important;">
          <div class="watchlist-wrapper" id="PropertyhighchartGraph{{properties.Id}}" style="display:none;">
            <div class="d-flex align-item-center">
              <h5 class="bluelabel bluelabel2 myPortfolioNormalHeading margin-bottom-40 p-l-d">{{properties.Name!=null?properties.Name:''}} <span class="propertyCount greentextlabel margin-left-5" *ngIf="properties.PropertyCount!=null">{{properties.PropertyCount!=null? properties.PropertyCount :''}}</span></h5>
            </div>
            <div class="row p-l-d">
              <div class="padding-left-32 col-lg-6 col-md-6 col-sm-6 border-left-10 col-xs-12">
                <div class="gray-box1 d-flex flex-direction-colum  margin-bottom-15">
                  <h5 class="bluelabel  bluelabe3 myPortfolioNormalHeading margin-top-0 margin-bottom-15">Cap Rate Highlights</h5>
                  <div class="be-market-data d-flex margin-bottom-15">
                    <div class="d-flex flex-direction-colum flex-1 margin-right-15">
                      <p class="bluelabel margin-bottom-10">{{properties.Name!=null?properties.Name:''}}</p>
                      <div class="d-flex in-box-t" *ngIf="properties.TotalStatusId!=null&&properties.TotalStatusId==1">
                        <span class="in-box">
                          <svg _ngcontent-serverApp-c331="" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path _ngcontent-serverApp-c331="" fill="#6A7175" d="M9 0C4.027 0 0 4.027 0 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9Zm0 2.25L15.75 9 9 15.75v-4.5H2.25v-4.5H9v-4.5Z"></path></svg>
                        </span>
                        <p class="margin-left-10 m-data whitespacenowrap">
                          {{(properties.TotalRate!=null&&properties.TotalRate>0)?(properties.TotalRate| number : '1.2-2'):'0.00'}} % <br />
                          <span class="gray-color">
                            <i container="body" class="userpermissiontooltip" triggers="mouseenter:mouseleave" aria-hidden="true" popover="{{properties.InfoTextTenant}}" popoverTitle="{{(properties.Name!=null?properties.Name:'')+' Cap Rate Info'}}" placement="right">
                              <img src="/assets/img/info-icon-blue.svg" class="info-icon-blue-position">
                            </i>
                            {{properties.TotalIncreased!=null&&properties.TotalIncreased>0?(properties.TotalIncreased| number : '1.2-2'):'0.00'}} %
                          </span>
                        </p>
                      </div>
                      <div class="d-flex gray-d-flex-box" *ngIf="properties.TotalStatusId!=null&&properties.TotalStatusId==0">
                        <span class="in-box">
                          <svg _ngcontent-serverApp-c331="" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path _ngcontent-serverApp-c331="" fill="#6A7175" d="M9 0C4.027 0 0 4.027 0 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9Zm0 2.25L15.75 9 9 15.75v-4.5H2.25v-4.5H9v-4.5Z"></path></svg>
                        </span>
                        <p class="margin-left-10 m-data whitespacenowrap">
                          {{(properties.TotalRate!=null&&properties.TotalRate>0)?(properties.TotalRate| number : '1.2-2'):'0.00'}} % <br />
                          <span class="gray-color">
                            <i container="body" class="userpermissiontooltip" triggers="mouseenter:mouseleave" aria-hidden="true" popover="{{properties.InfoTextTenant}}" popoverTitle="{{(properties.Name!=null?properties.Name:'')+' Cap Rate Info'}}" placement="right">
                              <img src="/assets/img/info-icon-blue.svg" class="info-icon-blue-position">
                            </i>
                            {{properties.TotalIncreased!=null&&properties.TotalIncreased>0?(properties.TotalIncreased| number : '1.2-2'):'0.00'}} %
                          </span>
                        </p>
                      </div>
                      <div class="d-flex in-box-d" *ngIf="properties.TotalStatusId!=null&&properties.TotalStatusId!=1&&properties.TotalStatusId!=0">
                        <span class="in-box">
                          <svg _ngcontent-serverApp-c331="" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path _ngcontent-serverApp-c331="" fill="#6A7175" d="M9 0C4.027 0 0 4.027 0 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9Zm0 2.25L15.75 9 9 15.75v-4.5H2.25v-4.5H9v-4.5Z"></path></svg>
                        </span>
                        <p class="margin-left-10 m-data whitespacenowrap">
                          {{(properties.TotalRate!=null&&properties.TotalRate>0)?(properties.TotalRate| number : '1.2-2'):'0.00'}} % <br /><span class="gray-color">
                            <i container="body" class="userpermissiontooltip" triggers="mouseenter:mouseleave" aria-hidden="true" popover="{{properties.InfoTextTenant}}" popoverTitle="{{(properties.Name!=null?properties.Name:'')+' Cap Rate Info'}}" placement="right">
                              <img src="/assets/img/info-icon-blue.svg" class="info-icon-blue-position">
                            </i>
                            {{properties.TotalIncreased!=null&&properties.TotalIncreased>0?(properties.TotalIncreased| number : '1.2-2'):'0.00'}} %
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="d-flex flex-direction-colum flex-1  padding-left-10" *ngIf="properties.PropertyType!=null">
                      <p class="bluelabel margin-bottom-10">{{properties.PropertyType!=null?properties.PropertyType:''}}</p>
                      <div class="d-flex in-box-t" *ngIf="properties.TypeStatusId!=null&&properties.TypeStatusId==1">
                        <span class="in-box">
                          <svg _ngcontent-serverApp-c332="" _ngcontent-serverApp-c331="" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path _ngcontent-serverApp-c332="" _ngcontent-serverApp-c331="" fill="#6A7175" d="M9 0C4.027 0 0 4.027 0 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9Zm0 2.25L15.75 9 9 15.75v-4.5H2.25v-4.5H9v-4.5Z"></path></svg>
                        </span>
                        <p class="margin-left-10 m-data whitespacenowrap">
                          {{properties.TypeCurrentRate!=null&&properties.TypeCurrentRate>0?(properties.TypeCurrentRate|number : '1.2-2'):'0.00'}} % <br /><span class="gray-color">
                            <i container="body" class="userpermissiontooltip" triggers="mouseenter:mouseleave" aria-hidden="true" popover="{{properties.InfoText}}" popoverTitle="{{(properties.PropertyType!=null?properties.PropertyType:'')+' Cap Rate Info'}}" placement="right">
                              <img src="/assets/img/info-icon-blue.svg" class="info-icon-blue-position">
                            </i>
                            {{properties.TypeIncrease!=null&&properties.TypeIncrease>0?(properties.TypeIncrease|number : '1.2-2'):'0.00'}} %
                          </span>
                        </p>
                      </div>
                      <div class="d-flex gray-d-flex-box" *ngIf="properties.TypeStatusId!=null&&properties.TypeStatusId==0">
                        <span class="in-box">
                          <svg _ngcontent-serverApp-c332="" _ngcontent-serverApp-c331="" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path _ngcontent-serverApp-c332="" _ngcontent-serverApp-c331="" fill="#6A7175" d="M9 0C4.027 0 0 4.027 0 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9Zm0 2.25L15.75 9 9 15.75v-4.5H2.25v-4.5H9v-4.5Z"></path></svg>
                        </span>
                        <p class="margin-left-10 m-data whitespacenowrap">
                          {{properties.TypeCurrentRate!=null&&properties.TypeCurrentRate>0?(properties.TypeCurrentRate|number : '1.2-2'):'0.00'}} % <br /><span class="gray-color">
                            <i container="body" class="userpermissiontooltip" triggers="mouseenter:mouseleave" aria-hidden="true" popover="{{properties.InfoText}}" popoverTitle="{{(properties.PropertyType!=null?properties.PropertyType:'')+' Cap Rate Info'}}" placement="right">
                              <img src="/assets/img/info-icon-blue.svg" class="info-icon-blue-position">
                            </i>
                            {{properties.TypeIncrease!=null&&properties.TypeIncrease>0?(properties.TypeIncrease|number : '1.2-2'):'0.00'}} %
                          </span>
                        </p>
                      </div>
                      <div class="d-flex in-box-d" *ngIf="properties.TypeStatusId!=null&&properties.TypeStatusId!=1&&properties.TypeStatusId!=0">
                        <span class="in-box">
                          <svg _ngcontent-serverApp-c332="" _ngcontent-serverApp-c331="" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"><path _ngcontent-serverApp-c332="" _ngcontent-serverApp-c331="" fill="#6A7175" d="M9 0C4.027 0 0 4.027 0 9s4.027 9 9 9 9-4.027 9-9-4.027-9-9-9Zm0 2.25L15.75 9 9 15.75v-4.5H2.25v-4.5H9v-4.5Z"></path></svg>
                        </span>
                        <p class="margin-left-10 m-data whitespacenowrap">
                          {{properties.TypeCurrentRate!=null&&properties.TypeCurrentRate>0?(properties.TypeCurrentRate|number : '1.2-2'):'0.00'}} % <br /><span class="gray-color">
                            <i container="body" class="userpermissiontooltip" triggers="mouseenter:mouseleave" aria-hidden="true" popover="{{properties.InfoText}}" popoverTitle="{{(properties.PropertyType!=null?properties.PropertyType:'')+' Cap Rate Info'}}" placement="right">
                              <img src="/assets/img/info-icon-blue.svg" class="info-icon-blue-position">
                            </i>
                            {{properties.TypeIncrease!=null&&properties.TypeIncrease>0?(properties.TypeIncrease|number : '1.2-2'):'0.00'}} %
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                  </div>
                </div>
                <p class="margin-bottom-10"><b>{{properties.Name != null?properties.Name:''}} Average Cap Rate:  <span class="gray-text" style="color:#6A7175">{{properties.TotalRate!=null&&properties.TotalRate>0?(properties.TotalRate|number : '1.2-2') +' %':'0.00 %'}}</span></b></p>
                <p class="margin-bottom-10"><b>{{properties.Name != null?properties.Name:''}} Available Properties: <span class="gray-text" style="color:#6A7175">{{properties.AvailableProperties!=null?properties.AvailableProperties:0}}</span></b></p>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 padding-left-65">
                <h5 class="graylabel margin-bottom-15 margin-top-0">Average Cap Rates</h5>
                <div id="PropertyContainer{{properties.Id}}"></div>
              </div>
              <div class="cf"></div>
              <div *ngIf="IsShowMyproperty==2||IsShowMyproperty==0">
                <a (click)="getMyProperties(properties.Id,i,properties)" class="btn-collapse" [class.span-open]="properties.ShowList">
                  <p class="accord" *ngIf="!properties.ShowList" style="padding-left:40px;">
                    <span *ngIf="PortfolioName=='My Portfolio'">Show My</span><span *ngIf="PortfolioName!='My Portfolio'">Show {{PortfolioName}}'s</span> {{properties.Name != null?properties.Name:''}}
                    <i class="fa fa-angle-right" aria-hidden="true" *ngIf="!properties.ShowList"></i>
                  </p><p class="accord" *ngIf="properties.ShowList" style="padding-left:40px;">Hide  <span *ngIf="PortfolioName=='My Portfolio'">My</span><span *ngIf="PortfolioName!='My Portfolio'">{{PortfolioName}}'s</span> {{properties.Name != null?properties.Name :''}}<i class="fa fa-angle-up" style="margin-left:5px" *ngIf="properties.ShowList"></i></p>
                </a>
              </div>
              <div *ngIf="properties.ShowList&&Isdata==0" class="margin-right-10 margin-left-10">
                <div class="text-right margin-bottom-0" style="padding-right:12px;">
                  <button class="btn btn-addgreen btn-lg btn-sell-market btn-medium" *ngIf="properties.showOffMarketButton" (click)="OnClickOffMarket(properties.Id,PropertyOffMarketModal,'property-Offmarket',properties.MyPropertyList);" tooltip="Sell Off-Market">SELL OFF-MARKET</button>
                </div>
                <div class="table-fixed table-v2 table-hd-line ">
                  <div class="table-responsive margin-top-20">
                    <table class="table basictable row-border hover">
                      <thead>
                        <tr>
                          <th style="width:100px">Tenant Name</th>
                          <th style="width:100px">Address</th>
                          <th style="width:100px">City</th>
                          <th style="width:100px">State</th>
                          <th style="width:100px">Lease Type</th>
                          <th style="width:100px">NOI</th>
                          <th style="width:100px">Remaining Term</th>
                          <!--<th style="width:100px">Status</th>-->
                          <th style="width:100px">BOV</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container>
                          <tr *ngFor="let myList of properties.MyPropertyList;let j = index ">

                            <td>
                              <p>
                                <span *ngIf="myList.IsIncludedInPortfolio==1" class="margin-right-10" container="body" tooltip="Portfolio Property"><img src="/assets/img/single-property.svg" title="Portfolio Property"></span>
                                <a href="javascript:void(0);" *ngIf="myList.PropertyType=='MyPortfolio'" routerLink="/property-detail/{{myList.Guid}}" [queryParams]="{UserGuid:UserGuid,prevroute:'Market Snapshot',link:'market-snapshot',opentab:'1'}">{{ myList.TenantName }}</a>
                                <a href="javascript:void(0);" *ngIf="myList.PropertyType!='MyPortfolio'" routerLink="/viewproperty/{{myList.Guid}}" [queryParams]="{UserGuid:UserGuid,prevroute:'Market Snapshot',link:'market-snapshot',opentab:'1'}">{{ myList.TenantName }}</a>
                              </p>
                            </td>
                            <td>
                              <p>
                                {{myList.PropertyAddress}}
                              </p>
                            </td>
                            <td>
                              <p>
                                {{myList.City}}
                              </p>
                            </td>
                            <td>
                              <p>
                                {{myList.State}}
                              </p>
                            </td>

                            <td>
                              <p>
                                {{myList.LeaseStructure}}
                              </p>
                            </td>
                            <td>
                              <p>
                                {{myList.RentNOI!=null? '$' +(myList.RentNOI | number:0):'-'}}
                              </p>
                            </td>
                            <td>
                              <p>
                                {{Validation.remainingTermForCardandTables(myList.LeaseExpiration, myList.LeaseCommencementDate)}}
                              </p>
                            </td>
                            <!--<td>
                              <p [ngClass]="{'redtextlabel':(myList.Status === 'Closed' ||myList.Status === 'Sold'),'greentextlabel':myList.Status === 'Available','orangetextlabel':myList.Status === 'Under Contract','not-available':myList.Status === 'Not Available','Off-Market':(myList.Status === 'Off-Market'||myList.Status === 'Portfolio')}">
                                {{myList.Status}}
                              </p>
                            </td>-->
                            <td class="text-right">
                              <button class="btn btn-success btn-lg" *ngIf="(myList.BovId==null||myList.BovId==0)&&(myList.PropertyId==null||myList.PropertyId==0)&&myList.DataentryPropertyStatusId!=6949" id="btnExcel1" (click)="RequestBov(myList.Guid,RequestBovModal,'portfolio-bov-modal');" tooltip="Request BOV">REQUEST BOV</button>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                      <tfoot>
                        <tr *ngIf="properties.MyPropertyList?.length == 0 ">
                          <td colspan="12" class="odd no-data-available">
                            <div class="nodata">
                              <i class="fa fa-exclamation-triangle icon"></i>
                              <p>No Data Available</p>
                            </div>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="row" *ngIf="(MyTenants==null||MyTenants?.length ==0)">
          <div class="nodata col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Data Available</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #AddToWatchList>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Add Tenants</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="form-label">
        Tenant Name
        <span class="star">*</span>
      </label>
      <div class="select-dropdown multiselectdesign">
        <tag-input [ngModel]="tenants" class="taginputclass" (onTextChange)="tenantSearch($event)" (onAdd)="onAdd($event,'Tenant')"
                   (onRemove)="onRemove($event,'Tenant')" [onlyFromAutocomplete]="true" secondaryPlaceholder="Search" placeholder="+ Tenants">
          <tag-input-dropdown [showDropdownIfEmpty]="true"
                              [autocompleteItems]="tenantlst">
          </tag-input-dropdown>
        </tag-input>
      </div>
      <!--<div class="select-dropdown multiselectdesign">
        <ss-multiselect-dropdown [options]="tenantList" [(ngModel)]="selectedTenants" [settings]="defaultTypeSettings" [texts]="defaultTypeText"></ss-multiselect-dropdown>
      </div>-->
    </div>
    <div class="text-right">
      <button type="button" (click)="modalRef.hide()" class="btn btn-default btn-lg">Cancel</button>
      <button type="button" (click)="AddTenant();" [disabled]="disableBtn" class="btn btn-success btn-lg">Save</button>
    </div>
  </div>

</ng-template>

<ng-template #RequestBovModal>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Would you like to request a BOV?</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefBov.hide();modelClose();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group" *ngIf="requestedProperties?.length==0">
      <!--<h6 class="displayvalue requestBovTitle">Would you like to request a BOV?</h6>-->
      <h6 class="info-text  margin-top-15 margin-bottom-30">Please add a property to request a BOV or talk to a broker.</h6>
    </div>
    <div class="row" *ngIf="requestedProperties!=null && requestedProperties?.length>0">
      <ul *ngFor="let myList of requestedProperties;let j = index ">
        <li class="transition" *ngIf="j==0">
          <label class="custom-checkbox withoutlabel margin-bottom-10">
            <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i> <span class="requestBovTenant">Select All</span>
          </label>
        </li>
        <li class="transition">
          <label class="custom-checkbox withoutlabel">
            <input type="checkbox" [(ngModel)]="myList.IsChecked" (change)="onCheckboxChange($event.target.checked,myList.Guid);" class="ng-pristine ng-valid ng-touched"><i></i> <span class="requestBovTenant">{{myList.TenantName}}</span>{{' - '+ myList.Address }}
          </label>
        </li>
      </ul>
    </div>
    <div class="text-right">
      <button type="button" *ngIf="(requestedProperties?.length==0&&(portfoliosummary==null||portfoliosummary.TotalProperties==0||portfoliosummary.TotalProperties==null)&&(this.authentication.Principal()||this.authentication.Principal1031()||this.authentication.Seller()))" (click)="contactBroker();modelClose();" class="btn btn-small no-border btn-default btn-lg">Contact Broker</button>
      <button class="btn btn-success btn-lg" *ngIf="requestedProperties?.length==0" (click)="openAddNewProperty();modalRefBov.hide();modelClose();"> + Add Property</button>
      <button class="btn btn-success btn-lg" *ngIf="requestedProperties!=null && requestedProperties?.length>0" (click)="SubmitBovRequest();">Request BOV</button>
    </div>
  </div>

</ng-template>

<ng-template #PropertyOffMarketModal>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Make Property Off-Market</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalOffMarket.hide();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-v2 padding30">
    <h4 class="Offmarket-MainHeading"> Confirm your property details</h4>
    <div class="form-group margin-top-20" *ngIf="pendingProperties!=null && pendingProperties?.length>0">
      <label class="form-label clearfix">
        Property
      </label>
      <label class="select  margin-bottom-50">
        <select class="form-control" name="lstProperty" (change)="onPropertyChanges();" [(ngModel)]="selectedPendindId">
          <option [ngValue]="null">Select</option>
          <option [ngValue]="item.Guid" *ngFor="let item of pendingProperties">{{item.TenantName}}{{item.Address!=null?(' - '+item.Address):''}}</option>
        </select>
        <i></i>
      </label>
      <div *ngIf="!IsValid">
        <p class="redtext">
          Property is required
        </p>
      </div>
    </div>

    <div class="margin-top-30" *ngIf="selectedPendingProperty!=null&&selectedPendingProperty.Guid!=null&&selectedPendingProperty.Guid!=''">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group margin-bottom-0">
            <h5 class="displayvalue font-18">{{selectedPendingProperty!=null&&selectedPendingProperty.TenantName!=null?selectedPendingProperty.TenantName:'-'}}</h5>
          </div>
        </div>
      </div>
      <div class="row margin-top-10">
        <div class="col-sm-12">
          <div class="form-group">
            <h6 class="font-16">{{selectedPendingProperty!=null&&selectedPendingProperty.Address!=null?selectedPendingProperty.Address:'-'}}</h6>
          </div>
        </div>
      </div>
      <div class="row margin-top-10" *ngIf="selectedPendingProperty!=null">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="blocklabel">Lease Structure</label>
            <h6 class="displayvalue">{{selectedPendingProperty!=null&&selectedPendingProperty.LeaseStructure!=null?selectedPendingProperty.LeaseStructure:'-'}}</h6>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="blocklabel">Ownership Type</label>
            <h6 class="displayvalue">{{(selectedPendingProperty!=null&&selectedPendingProperty.OwnershipType!=null)?selectedPendingProperty.OwnershipType:'-'}}</h6>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="selectedPendingProperty!=null">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="blocklabel">Net Operting Income</label>
            <h6 class="displayvalue">{{(selectedPendingProperty!=null&&selectedPendingProperty.RentNOI!=null)?('$ ' + Validation.decimalCommaFormat(selectedPendingProperty.RentNOI)):'-'}}</h6>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="blocklabel">Remaining Term</label>
            <h6 class="displayvalue">{{(selectedPendingProperty!=null&&selectedPendingProperty.Remaining_Term!=null&&selectedPendingProperty.Remaining_Term!=undefined)?selectedPendingProperty.Remaining_Term:'-'}}</h6>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right margin-top-30">
      <button type="button" class="btn btn-3x-border btn-small btn-lg btn-property-edit-nobackground margin-right-10" (click)="onclickEditProperty()">EDIT PROPERTY</button>
      <button class="btn btn-lg btn-addgreen" (click)="proceedPricing()"> PROCEED TO PRICING</button>
    </div>
  </div>

</ng-template>
<ng-template #QuickEdit>
  <app-quick-edit-myportfolio [selectedPropertyId]="selectedPendindId" [propertyBasicDetails]="selectedPendingProperty" [source]="'MyportfolioDashboard'" (closeModal)="closeModal($event)" (closeButtonModel)="closeButtonModel($event)" [isDataEntryProperty]="true"></app-quick-edit-myportfolio>
</ng-template>
<button id="openModalChangeToOffMarketButton" [hidden]="true" (click)="openModalForQuickEdit(QuickEdit,'property-Offmarket')"></button>




